export interface ITicketDepartment {
        ID: number;
        Name: string;
        Description: string;
        EmailAddress: string;
        Autoresponder: boolean;
        FeedbackRequest: boolean;
        ClientsOnly: boolean;
        Hidden: boolean;

}

export class TicketDepartmentArray extends Array<TicketDepartment>  {

        constructor(...items: TicketDepartment[]) {
            super(...items);
            Object.setPrototypeOf(this, TicketDepartmentArray.prototype);
        }
    }

export class TicketDepartment implements ITicketDepartment {
        ID: number;
        Name: string;
        Description: string;
        EmailAddress: string;
        Autoresponder: boolean;
        FeedbackRequest: boolean;
        ClientsOnly: boolean;
        Hidden: boolean;

}
